import { Col, Nav, Row, Tab } from "react-bootstrap";
import { ClipboardCheck, Person, ShieldCheck } from "react-bootstrap-icons";
import EliglibilityResposne from "features/eliglibility/eliglibility-check/components/EliglibilityResposne";
import { useSelector } from "react-redux";

import { useEffect, useState } from "react";
import ClaimProviderRequest from "./ClaimProviderRequest";
import ClaimPayerRespon from "./ClaimPayerRespon";
const CliamViewResponse = () => {
  const { viewClaimInfo } = useSelector((state) => state.claim);
  const { allPermissionType } = useSelector((state) => state.role);
  const claimsSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) =>
      item?.rolemngmttyp_name === "Claim" ||
      item?.rolemngmttyp_name === "Claims"
  );
  // Add activeKey to control the active tab
  const [activeKey, setActiveKey] = useState("mainPayer");
  useEffect(() => {
    if (!!viewClaimInfo?.payer_response?.claim_type) {
      setActiveKey("mainPayer");
    } else {
      setActiveKey("provider");
    }
  }, [viewClaimInfo]);

  return (
    <>
      {Number(claimsSetting?.view) === 1 ? (
        <Tab.Container defaultActiveKey={activeKey} onSelect={setActiveKey}>
          <Row>
            {/* Sidebar Tabs */}
            <Col xs={12} xl={1}>
              <div className="mb-25 mt-lg-8 flex-lg-column">
                <Nav
                  variant="pills"
                  className="custom-tabs flex-xl-column flex-row"
                  fill
                  justify
                >
                  {!!viewClaimInfo?.payer_response?.claim_type && (
                    <Nav.Item>
                      <Nav.Link eventKey="mainPayer">
                        <span className="tab-label">
                          <Person
                            size={24}
                            className="mb-1 text-body-emphasis"
                          />
                          <span className="fs-12 text-nowrap text-body-emphasis">
                            Payer Response
                          </span>
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                  )}
                  <Nav.Item>
                    <Nav.Link eventKey="provider">
                      <span className="tab-label">
                        <ClipboardCheck
                          size={24}
                          className="mb-1 text-body-emphasis"
                        />
                        <span className="fs-12 text-nowrap text-body-emphasis">
                          Provider Request
                        </span>
                      </span>
                    </Nav.Link>
                  </Nav.Item>

                  {viewClaimInfo?.payer_response?.eligbid && (
                    <Nav.Item>
                      <Nav.Link eventKey="member">
                        <span className="tab-label">
                          <ShieldCheck
                            size={24}
                            className="mb-1 text-body-emphasis"
                          />
                          <span className="fs-12 text-nowrap text-body-emphasis">
                            Eligibility
                          </span>
                        </span>
                      </Nav.Link>
                    </Nav.Item>
                  )}
                </Nav>
              </div>
            </Col>

            {/* Content Area */}
            <Col xs={12} xl={11}>
              <Tab.Content className="p-3">
                <Tab.Pane eventKey="mainPayer">
                  <ClaimPayerRespon />
                </Tab.Pane>
                <Tab.Pane eventKey="provider">
                  <ClaimProviderRequest />
                </Tab.Pane>
                <Tab.Pane eventKey="member">
                  <EliglibilityResposne />
                  {/* EliglibilityResposne */}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      ) : (
        <div className="py-6 text-center border rounded-3mb-3">
          <h5 className="text-danger">Permission Denied</h5>
          <p className="text-muted fs-11">
            You do not have permission to view this claim response.
          </p>
        </div>
      )}
    </>
  );
};

export default CliamViewResponse;
